import React from 'react';
import BaseToggle from 'src/shared/components/inputs/BaseToggle';

const PinnedOnlyControl = (props) => (
  <div className='control-wrapper'>
    <BaseToggle id='pinnedOnly' {...props} />
  </div>
);

export default PinnedOnlyControl;
